import { MessageCircle } from "lucide-react";
import { WHATSAPP } from "@/lib/api";

export default function WhatsAppFloat() {
  const url = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(
    "Hello, I'm interested in your premium plots at Shujalpur. Please share more details."
  )}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 blur-xl animate-pulse" />
      <span className="relative inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-2xl transition-transform group-hover:scale-110">
        <MessageCircle size={26} />
      </span>
    </a>
  );
}
